const AccountType = { Customer: 'Customer', Vendor: 'Vendor' };

export default AccountType;
